import { Controller } from "@hotwired/stimulus"
import { turboStreamRequest } from "../admin/club_announcements/turbo_stream_helpers"

export default class extends Controller {
  static targets = ["scopeMenu", "scopeThis", "scopeAll"]

  showScopeMenu(event) {
    event.preventDefault()
    const button = event.currentTarget
    this.pendingDecision = button.dataset.decision
    this.pendingDate = button.dataset.date
    this.pendingUrl = button.dataset.url

    // Highlight selected button
    this.clearSelection()
    const classes = button.dataset.selectedClass?.split(' ')
    if (classes) {
      button.classList.remove('bg-white', 'text-gray-700')
      button.classList.add(...classes, 'opacity-70')
      button.dataset.active = true
    }

    if (this.hasScopeMenuTarget) {
      this.scopeMenuTarget.classList.remove("hidden")
      this.scopeMenuTarget.classList.add("flex")
    }
  }

  clearSelection() {
    this.element.querySelectorAll('button[data-active]').forEach(b => {
      const classes = b.dataset.selectedClass?.split(' ')
      if (classes) b.classList.remove(...classes, 'opacity-70')
      b.classList.add('bg-white', 'text-gray-700')
      delete b.dataset.active
    })
  }

  submitDirect(event) {
    event.preventDefault()
    const { url, method, date, decision, param } = event.currentTarget.dataset
    const paramName = param || 'decision'
    let queryString = `${paramName}=${decision}`
    if (date) queryString += `&date=${date}`

    turboStreamRequest(`${url}?${queryString}`, method || 'POST')
  }

  submitThis(event) {
    event.preventDefault()
    this.submitDecision(this.pendingDate)
  }

  submitAll(event) {
    event.preventDefault()
    this.submitDecision(null)
  }

  submitDecision(date) {
    if (!this.pendingUrl || !this.pendingDecision) return

    let url = `${this.pendingUrl}?decision=${this.pendingDecision}`
    if (date) url += `&date=${date}`

    turboStreamRequest(url, 'POST')
  }
}
